import React from 'react';
import { observer } from '../../shared/observer';

// Blocking-модалка выбора города. Аналог
// `waterapp_client/src/shared/Modals/ChooseCityModal`.
//
// Видна когда у токена нет выбранного city_branch И в company.city_branches
// больше одного активного. Если филиал один — бэкенд (`ensure_mobile_token`)
// проставляет его сам, и модалка никогда не рендерится.
//
// Также можно открыть руками (например, из шапки) — тогда показывается
// при любом числе филиалов; на выбор любого закрывается.
class CityBranchDialogView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { busy: false, busyId: null, error: null };
    this.handleChoose = this.handleChoose.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  async handleChoose(id) {
    if (this.state.busy) return;
    this.setState({ busy: true, busyId: id, error: null });
    try {
      await this.props.auth.setCity(id);
      // Диалог не закрываем — спиннер на кнопке держится до перезагрузки страницы.
      window.location.reload();
    } catch (e) {
      this.setState({ busy: false, busyId: null, error: 'Не удалось выбрать город' });
    }
  }

  handleClose() {
    if (this.state.busy) return;
    if (this.props.auth.cityBranch) {
      this.props.auth.setCityBranchDialogOpen(false);
    }
  }

  render() {
    const auth = this.props.auth;
    const branches = auth.cityBranches || [];
    const current = auth.cityBranch;
    const forcedOpen = !current && branches.length > 1;
    const isOpen = forcedOpen || auth.cityBranchDialogOpen;
    if (!isOpen) return null;

    const currentId = current && current.id;

    return (
      <div className="dialog">
        <div className="dialog__bg" onClick={this.handleClose} />
        <div className="dialog__content">
          {current && <div className="dialog__close" onClick={this.handleClose} />}
          <h2 className="ng-city-dialog__title">Выберите город</h2>
          <div className="ng-city-dialog__list">
            {branches.map((cb) => (
              <button
                type="button"
                key={cb.id}
                className={
                  'ng-city-dialog__item'
                  + (cb.id === currentId ? ' ng-city-dialog__item--active' : '')
                  + (cb.id === this.state.busyId ? ' is-busy' : '')
                }
                disabled={this.state.busy}
                onClick={() => this.handleChoose(cb.id)}
              >
                {cb.title}
              </button>
            ))}
          </div>
          {this.state.error && <div className="order-message">{this.state.error}</div>}
        </div>
      </div>
    );
  }
}

export const CityBranchDialog = observer(CityBranchDialogView, ['authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/CityBranch/CityBranchDialog.jsx